/* "Sep 22, 2026 9:02AM"; shares the workflows formatter so both pages read alike */
export { formatWorkflowTimestamp as formatTimestamp } from 'components/BrandWorkflows/workflowFormatters';

export const formatNumber = (value: number | null | undefined): string =>
  value == null ? '—' : value.toLocaleString('en-US');

export const formatPercent = (value: number | null | undefined): string =>
  value == null ? '—' : `${Number((value * 100).toFixed(1))}%`;

export const formatSpend = (value: number | null | undefined): string =>
  value == null
    ? '—'
    : value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
      });

/* A Meta effective status such as "CAMPAIGN_PAUSED", as "Campaign paused" */
export const formatMetaStatus = (status: string | null): string =>
  status ? `${status.charAt(0)}${status.slice(1).toLowerCase().replaceAll('_', ' ')}` : '—';

/**
 * A user id without its provider prefix, for a table cell.
 *
 * - An email, such as "google-apps|ben@proxima.ai", shows whole; the cell clips it if it does not fit.
 * - An opaque id, such as "auth0|a1b2c3d4…", is noise, so it is shortened.
 */
export const formatUserId = (userId: string | null): string => {
  if (!userId) return '—';
  const tail = userId.includes('|') ? userId.split('|')[1] : userId;
  if (tail.includes('@')) return tail;
  return tail.length > 10 ? `${tail.slice(0, 8)}…` : tail;
};

/** A timestamp split into its date and time lines, such as "Sep 22, 2026" and "9:02AM", or null when unset or invalid. */
export const formatTimestampLines = (
  isoDate: string | null
): { date: string; time: string } | null => {
  if (!isoDate) return null;
  const value = new Date(isoDate);
  if (Number.isNaN(value.getTime())) return null;
  return {
    date: value.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
    time: value
      .toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
      .replace(' ', '')
  };
};

/** A header stamp's time, such as "Oct 1, 2026 at 1:00 PM". */
export const formatStampTime = (value: Date): string =>
  `${value.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} at ${value.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}`;
